import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkVerificationStatus, getCompanyInfo } from "store/actions/authSlice";


import Spinners from "components/common/Spinners";

const AuthLayoutWithoutSidebar = ({ children }) => {
    const { isGettingUserDetails } = useSelector((state) => state.auth);
    const userId = localStorage.getItem('authUserId');
    const dispatch = useDispatch();

    useEffect(() => {
        const isLogin = JSON.parse(localStorage.getItem("isLoggedIn"));

        

    }, []);

    return (
        <React.Fragment>
            <div id="layout-wrapper">
                {isGettingUserDetails ? <Spinners /> : <>{children}</>}
            </div>
        </React.Fragment>
    );
};

export default AuthLayoutWithoutSidebar;
